import React, {
    useState,
    useEffect,
    useLayoutEffect,
    useRef
} from 'react';
import { useQuery } from '@tanstack/react-query';

import { getCustomer } from "../router";

import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";
import CardCarousel from '../components/card-carousel';

import { formatDate, sub } from 'date-fns';

const UpcomingTickets = (props) => {

    const { data: customer } = getCustomer();

    const [upcomingTickets, setUpcomingTickets] = useState(null);

    const { 
        isPending: upcomingTicketsPending,
        data: upcomingTicketsData,
    } = useQuery({
        queryKey: ['upcomingTickets', customer.id],
        enabled: !!customer?.id,
        queryFn: () => QUERIES.getAuthenticatedOrders(customer.id,null,null,true), // if it is NOT a higher-order fn already
        // If getAuthenticatedOrders already returns a function, keep: queryFn: QUERIES.getAuthenticatedOrders(customer.id)
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (!upcomingTicketsData) return;

        const upcoming = UTILS.getUpcomingTickets(upcomingTicketsData, true);
        setUpcomingTickets(upcoming);
    }, [upcomingTicketsData]);
    if (!upcomingTicketsData && !upcomingTicketsPending) return null

    return (
        <CardCarousel
            cards={upcomingTickets}
            className="upcoming-tickets"
            title="Upcoming bookings"
            pending={upcomingTicketsPending}
        />
    );
};

export default UpcomingTickets;